import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import './ResidualListItem.scss';

export default class ResidualListItem extends Component {
    static propTypes = {
        item: PropTypes.any,
        onGoToItem: PropTypes.func.isRequired
    };

    renderResidualAgent(agentName) {
        return agentName ? agentName : 'No Agent';
    }

    renderResidualRepCode(repCode) {
        return repCode ? repCode : 'No RepCode';
    }

    render() {
        const residual = this.props.item;

        return (
            <div
                className="residual-list-item"
                onClick={this.props.onGoToItem}
            >
                <div className="residual-list-item-left">
                    <span className="residual-residual-agent">
                        {this.renderResidualAgent(residual.agentName)}
                    </span>
                    <span className="residual-residual-repcode">
                        {this.renderResidualRepCode(residual.repCode)}
                    </span>
                </div>
                <div className="residual-list-item-right">
                    <span className="residual-income">
                        <ColorDollarAmountCell amount={residual.income} />
                    </span>
                </div>
            </div>
        );
    }
}
